import axios from 'axios';
import { URL_PATHS } from 'config/constants/api.constants';
import {
  ConfirmPurchaseInput,
  ConfirmPurchaseResponse,
  GetOrderDetailsInput,
  GetOrderDetailsResponse,
  InitPurchaseInput,
  InitPurchaseResponse,
  PaymentStatusResponse,
  VerifyCouponInput,
  VerifyCouponResponse,
} from 'config/types/order.type';
import NavigationUtils from 'config/utils/navigation.util';
import queryString from 'query-string';

const initPurchase = (data: InitPurchaseInput, idempotencyKey?: string | null): Promise<InitPurchaseResponse> => {
  const headers = idempotencyKey ? { 'x-idempotency-key': idempotencyKey } : {};
  return axios.post(`${URL_PATHS.API_ORDER_V1}/purchase/init`, data, { headers });
};

const confirmPurchase = (input: ConfirmPurchaseInput): Promise<ConfirmPurchaseResponse> => {
  return axios.post(`${URL_PATHS.API_ORDER_V1}/purchase/confirm`, input);
};

const verifyCoupon = (data: VerifyCouponInput): Promise<VerifyCouponResponse> => {
  const { couponCode, items, isDelivery, isPickup, selectedAddressForCheckout } = data;
  const queryParams = {
    items: JSON.stringify(items),
    isDelivery,
    isPickup,
    selectedAddressForCheckout: JSON.stringify(selectedAddressForCheckout),
  };
  const query = queryString.stringify(queryParams, NavigationUtils.queryStringOptions);
  return axios.get(`${URL_PATHS.API_ORDER_V1}/coupon/${couponCode}/verify?${query}`);
};

const getOrderDetails = (input: GetOrderDetailsInput): Promise<GetOrderDetailsResponse> => {
  return axios.get(`${URL_PATHS.API_ORDER_V1}/purchase/${input.entryCode}/details`);
};

const getPaymentStatus = (entryCode: string): Promise<PaymentStatusResponse> => {
  return axios.get(`${URL_PATHS.API_ORDER_V1}/purchase/${entryCode}/payment-status`);
};

const OrderService = {
  initPurchase,
  confirmPurchase,
  verifyCoupon,
  getOrderDetails,
  getPaymentStatus,
};

export default OrderService;
